import axios from 'axios';
import {useMutation} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const addOrRemoveFavorite = async (id?: number) =>
  axios.post(Routes.PRODUCT_PREFIX + '/' + id + '/' + Routes.FAVORITE);

export const useFavorite = (id: number) => {
  return useMutation({
    mutationKey: [Keys.FAVORITE_MUT, id],
    mutationFn: () => addOrRemoveFavorite(id),
  });
};
